/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meta_Event_Status_CompleteInputs */



/**
* | output |
* | --- |
* | "Complete" |
*
* @param {Meta_Event_Status_CompleteInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const meta_event_status_complete = /** @type {((inputs?: Meta_Event_Status_CompleteInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meta_Event_Status_CompleteInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Abgeschlossen")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Terminé")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("已结束")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("已結束")
	if (locale === "ko") return /** @type {LocalizedString} */ ("종료")
	return /** @type {LocalizedString} */ ("Complete")
});